/**
 * Created by richardlovejoy on 2/16/17.
 */

import Phaser from 'phaser';
import NumberDisplay from './NumberDisplay';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const BackboardMeter = function(game) {

  Phaser.Group.call(this, game);
  this.name = 'BackboardMeter';

  this.init();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
BackboardMeter.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: BackboardMeter,


  init() {


    // score
    this.scoreMeter = Object.create(NumberDisplay).init(this.game, this, 440, 9, 4, [0.68, 0.74, 0.74, 0.68], {
      hideLeadingZeroes: true,
      showDigitBack: true
    });

    // winner text
    this.winnerText = this.game.add.image(0, 0, 'skee', 'winnerText.png', this);
    this.winnerText.visible = false;

    // listen for score changes
    this.game.logic.onSignalScoreChanged.add(newScore => {

      // roll score meter
      this.scoreMeter.roll(newScore);

    });

    return this;
  },

  frameUpdate(dt) {

    this.scoreMeter.frameUpdate(dt);
  },

  toggleWinnerText() {

    // turn 'winner text' on and off
    this.winnerText.visible = !this.winnerText.visible;

  }

});

export default BackboardMeter;



// WEBPACK FOOTER //
// ./app/src/display/meters/BackboardMeter.js